import SizeSelector from './sizeSelector';

export default SizeSelector;